import { Tip as WordpressTip } from '@wordpress/components';

type NotificationProps = {
  color?: 'gray' | 'blue' | 'red' | 'green';
  children: React.ReactNode;
  className?: string;
};

export const Notification = ({ children }: NotificationProps) => {
  return <WordpressTip>{children}</WordpressTip>;
};
